import { render, staticRenderFns } from "./PartnerHome.vue?vue&type=template&id=7d36bc14"
import script from "./PartnerHome.vue?vue&type=script&lang=ts"
export * from "./PartnerHome.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports